<template>
      <div class="row">
        <div class="col-md-12">
            <div class="form-inline" v-if="meta.is_active" >
                <label class="mr-2">Filter Table</label>
                <select class="form-control" v-model="meta.is_active" @change="loadIsActive">
                    <option value="2">Show All</option>
                    <option value="1">Show Only Active</option>
                    <option value="0">Show Only Inactive</option>
                </select>
            </div>
            <div class="clearfix"><br></div>
        </div>
        <div class="col-md-4 mb-2">
            <div class="form-inline">
                <label class="mr-2">Showing</label>
                <select class="form-control" v-model="meta.per_page" @change="loadPerPage">
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                </select>
                <label class="ml-2">Entries</label>
            </div>
        </div>
      
        <div class="col-md-4 offset-md-4"> 
            <!-- SEARCH BY DATE -->
            <div class="form-inline float-right" v-if="is_search_by_date">
                <label class="mr-2">Search by Date</label>
                <input type="date" class="form-control" @input="search">
            </div>
            <!-- SEARCH DEFAULT -->
            <div class="form-inline float-right mb-3" v-else>
                <label class="mr-2">Search</label>
                <input type="text" class="form-control" @input="search">
            </div>
        </div>

        <div class="col-md-12">
            <CDataTable striped hover bordered :items="items" :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" show-empty >

              <template #available="{item}">
                <td v-if="item.available == 'a'">Private</td>
                <td v-if="item.available == 'b'">ICC</td>
                <td v-if="item.available == 'c'">ICL and Core Team</td>
                <td v-if="item.available == 'd'">HOD</td>
                <td v-if="item.available == 'e'">Volunteers and Covenants</td>
                <td v-if="item.available == 'f'">Youth</td>
                <td v-if="item.available == 'g'">Everyone</td>
              </template>                

              <template #action="{item}">
                <td v-if="item.status == 'publish'" style='width:250px'> 
                    <CDropdown
                        placement="bottom-end"
                        :offset="[-70, -35]"
                        toggler-text="Action"
                        color="primary"
                        class="m-2 d-inline-block"
                        size="sm"
                        >
                        <CDropdownItem @click="showEvent(item.id)">Show Event Information</CDropdownItem>
                        <CDropdownItem @click="editEvent(item.id)">Edit Event Information</CDropdownItem>
                        <CDropdownItem @click="editEventDescription(item.id)">Edit Event Description</CDropdownItem>
                        <CDropdownItem @click="showRegistrationPage(item.registration_link)">Show Registration Page</CDropdownItem>
                        <CDropdownItem @click="doCopyRegistrationPage(item.registration_link)">Copy Registration Link</CDropdownItem>
                        <CDropdownItem @click="doCopyQRCodePage(item.id)">Copy QRCode Scanner Link</CDropdownItem>
                        <CDropdownItem @click="doCopyAttendanceListPage(item.id)">Copy Attendance List Link</CDropdownItem>
                        <CDropdownItem @click="reportAttendance(item.id)">Report Attendance</CDropdownItem>
                        <!-- <CDropdownItem @click="showEventOrder(item.id)">Show Event Order</CDropdownItem> -->
                        <CDropdownItem v-if="item.is_active == 1" @click="cancelation(item.id)">Cancellation</CDropdownItem>
                        <CDropdownItem v-if="item.is_active == 1" @click="deactivate(item.id)">Deactivate</CDropdownItem>
                        <CDropdownItem v-if="item.is_active == 0" @click="reactivate(item.id)">Reactivate</CDropdownItem>
                    </CDropdown>
                </td>    
                <td v-else-if="item.status == 'draft'" style='width:250px'> 
                    <CDropdown
                        placement="bottom-end"
                        :offset="[-70, -35]"
                        toggler-text="Action"
                        color="primary"
                        class="m-2 d-inline-block"
                        size="sm"
                        >
                      <CDropdownItem @click="showEvent(item.id)">Show Event Information</CDropdownItem>
                        <CDropdownItem @click="editEvent(item.id)">Edit Event Information</CDropdownItem>
                        <!-- <CDropdownItem @click="showRegistration(item.registration_link)">Show Registration</CDropdownItem>                         -->
                        <CDropdownItem @click="changeToPublish(item.id)">Change To Publish</CDropdownItem>
                        <CDropdownItem v-if="item.is_active == 1" @click="deactivate(item.id)">Deactivate</CDropdownItem>
                        <CDropdownItem v-if="item.is_active == 0" @click="reactivate(item.id)">Reactivate</CDropdownItem>
                    </CDropdown>
                </td> 
                
              </template>
          

            </CDataTable>   
        </div>

        <div class="col-md-6">
            <p>Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} items</p>
        </div>
      
        <div class="col-md-6">
            <b-pagination
                v-model="meta.current_page"
                :total-rows="meta.total"
                :per-page="meta.per_page"
                align="right"
                @change="changePage"
                aria-controls="dw-datatable"
            ></b-pagination>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment';
import axios from 'axios'
import store from '@/store.js'

export default {
  name: 'Table',
  props: {
    items: Array,
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,
    items: {
        type: Array,
        required: true
    },
    fields: {
        type: Array,
        required: true
    },
    meta: {
        required: true
    },
    btn_show: {
        required: true
    },
    btn_edit: {
        required: true
    },
    btn_deactivate: {
        required: true
    },
    btn_reactivate: {
        required: true
    },
    btn_destroy: {
        required: true
    },
    is_uuid: {
        required: true
    },
    is_search_by_date: {
        required: true
    },

  },
  data() {
      return {
          sortBy: null, 
          sortDesc: false, 
          deleteModal: false,
          selected: null,
          selectID: null,
          inc: 5,
      }
  },
    watch: {
        sortBy(val) {
            this.$emit('sort', {
                sortBy: this.sortBy,
                sortDesc: this.sortDesc
            })
        },
        sortDesc(val) {
            this.$emit('sort', {
                sortBy: this.sortBy,
                sortDesc: this.sortDesc
            })
        }
    },
   methods:{

   getPhoto(data){
        if (data){
            return axios.defaults.baseURL + '/getfile/memberphoto/' + data
        }else{
            return axios.defaults.baseURL + '/getfile/memberphoto/no_photo.jpg'
        } 
     
    }, 
  
      loadPerPage(val) {
          this.$emit('per_page', this.meta.per_page)
      },

      loadIsActive(val) {
          this.$emit('is_active', this.meta.is_active)
      },

      changePage(val) {
          this.$emit('pagination', val)
      },

      search: _.debounce(function (e) {
          this.$emit('search', e.target.value)
      }, 500),

      showEvent: function (id) {
          this.$emit('showEvent', id)
      },

      editEvent: function (id) {
          this.$emit('editEvent', id)
      },      
      editEventDescription: function (id) {
          this.$emit('editEventDescription', id)
      }, 

      showRegistrationPage: function (registration_link) {
          this.$emit('showRegistrationPage', registration_link)
      },

      showEventOrder: function (id) {
          this.$emit('showEventOrder', id)
      },

      changeToPublish: function (id) {
          this.$emit('changeToPublish', id)
      },
      cancelation: function (id) {
        this.$emit('cancelation', id)
      },
      reportAttendance: function (id) {
        this.$emit('reportAttendance', id)
      },
      deactivate: function (id) {
        this.$emit('deactivate', id)
      },
      
      reactivate: function (id) {
        this.$emit('reactivate', id)
      },

      destroy: function (id) {
        this.$emit('destroy', id)
      },

      frontEndDateFormat: function(date) {
        return moment(date, 'YYYY-MM-DD').format('DD MMMM YYYY');
      },
      doCopyRegistrationPage: function (value) {
        this.$copyText("https://portal.ifgfsby.org/#/event-registration?id="+value).then(function (e) {
          alert('Copied')
          console.log(e)
        }, function (e) {
          alert('Can not copy')
          console.log(e)
        })
      },
      doCopyQRCodePage: function (value) {
        this.$copyText("https://portal.ifgfsby.org/#/event-scan?id="+value).then(function (e) {
          alert('Copied')
          console.log(e)
        }, function (e) {
          alert('Can not copy')
          console.log(e)
        })
      },
      doCopyAttendanceListPage: function (value) {
        this.$copyText("https://portal.ifgfsby.org/#/event_detail_attendance?id="+value).then(function (e) {
          alert('Copied')
          console.log(e)
        }, function (e) {
          alert('Can not copy')
          console.log(e)
        })
      }
  }
 
}
</script>

